import {
    SelfExclusionAppliedNotificationType,
    SelfExclusionNotificationType,
    SelfExclusionRemovedNotificationType,
} from 'src_server/types/notificationData';

export const SELF_EXCLUSION_CHANNEL = 'self-exclusion-changes';
export const SELF_EXCLUSION_TYPE_APPLIED = 'self-exclusion-applied';
export const SELF_EXCLUSION_TYPE_REMOVED = 'self-exclusion-removed';

export const isSelfExclusionNotification = (notification: {
    type: string;
}): notification is SelfExclusionNotificationType => {
    return notification.type === SELF_EXCLUSION_TYPE_APPLIED || notification.type === SELF_EXCLUSION_TYPE_REMOVED;
};

export const getSelfExclusionNotificationEntity = (
    notification: SelfExclusionNotificationType
): typeof SELF_EXCLUSION_TYPE_APPLIED | typeof SELF_EXCLUSION_TYPE_REMOVED => {
    return notification.type;
};

export const isSelfExclusionAppliedNotification = (
    notification: SelfExclusionNotificationType
): notification is SelfExclusionAppliedNotificationType => {
    return notification.type === SELF_EXCLUSION_TYPE_APPLIED;
};

export const isSelfExclusionRemovedNotification = (
    notification: SelfExclusionNotificationType
): notification is SelfExclusionRemovedNotificationType => {
    return notification.type === SELF_EXCLUSION_TYPE_REMOVED;
};
